import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, CircleIcon } from 'lucide-react';
interface ChecklistItem {
  id: string;
  text: string;
  completed: boolean;
}
const defaultChecklist: ChecklistItem[] = [{
  id: '1',
  text: 'Cont & profil complet (foto, date, disponibilitate)',
  completed: false
}, {
  id: '2',
  text: 'Acces platformă pro.cautlocuinta.ro (CRM, liste, cereri, tranzacții)',
  completed: false
}, {
  id: '3',
  text: 'Branding agent (email, semnătură, kit vizual)',
  completed: false
}, {
  id: '4',
  text: 'Grupuri de suport (tehnic, imobiliar, legal, fiscal)',
  completed: false
}, {
  id: '5',
  text: 'Mini-training de inițiere (navigare + reguli)',
  completed: false
}, {
  id: '6',
  text: 'Plan 7 zile – primele obiective',
  completed: false
}];
export function ChecklistSection() {
  const [items, setItems] = useState<ChecklistItem[]>(defaultChecklist);
  const toggleItem = (id: string) => {
    setItems(items.map(item => item.id === id ? {
      ...item,
      completed: !item.completed
    } : item));
  };
  const completedCount = items.filter(item => item.completed).length;
  const progress = completedCount / items.length * 100;
  return <div className="bg-gradient-to-br from-[#21A366] to-[#1a8555] rounded-2xl p-8 text-white shadow-xl" data-id="element-602">
      <div className="mb-6" data-id="element-603">
        <div className="flex items-center justify-between mb-2" data-id="element-604">
          <h3 className="text-lg font-bold" data-id="element-605">Checklist Onboarding</h3>
          <span className="text-sm bg-white bg-opacity-20 px-3 py-1 rounded-full" data-id="element-606">
            {completedCount}/{items.length}
          </span>
        </div>
        <div className="w-full bg-white bg-opacity-20 rounded-full h-2" data-id="element-607">
          <motion.div initial={{
          width: 0
        }} animate={{
          width: `${progress}%`
        }} transition={{
          duration: 0.5
        }} className="bg-white h-2 rounded-full" data-id="element-608" />
        </div>
      </div>
      <div className="space-y-3" data-id="element-609">
        {items.map((item, index) => <motion.button key={item.id} initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.3,
        delay: index * 0.1
      }} onClick={() => toggleItem(item.id)} className="w-full flex items-start space-x-3 text-left p-4 rounded-xl bg-white bg-opacity-10 hover:bg-opacity-20 transition-all" data-id="element-610">
            {item.completed ? <CheckCircleIcon className="w-6 h-6 flex-shrink-0 text-white" data-id="element-611" /> : <CircleIcon className="w-6 h-6 flex-shrink-0 text-white opacity-50" data-id="element-612" />}
            <span className={`flex-1 ${item.completed ? 'line-through opacity-75' : ''}`} data-id="element-613">
              {item.text}
            </span>
          </motion.button>)}
      </div>
      <div className="mt-6 bg-white bg-opacity-10 border-l-4 border-white p-4 rounded-r-xl" data-id="element-614">
        <p className="text-sm" data-id="element-615">
          💡 <strong data-id="element-616">Notă:</strong> Un onboarding bun = start rapid. Bifează
          disponibilitatea zilnică în platformă.
        </p>
      </div>
    </div>;
}